import { createFileRoute } from '@tanstack/react-router'
import { FraudAnalysisDatasetEventsPage, fraudScoreLabelledEventsQueryOptions } from 'features/fraudAnalysis'
import uniq from 'lodash/uniq'
import { LabelSourceType } from 'models'
import { z } from 'zod/v4'

// These filters go to Legendary Blade as is, and it answers an empty value with a 400. Drop them here
// instead, so a hand-edited URL degrades to "unfiltered" rather than erroring.
const nonEmptyStrings = z.array(z.string().trim().min(1)).transform(uniq).optional().catch(undefined)

export const fraudAnalysisDatasetEventsSearchSchema = z.object({
  eventId: nonEmptyStrings,
  visitorId: nonEmptyStrings,
  labelSlug: nonEmptyStrings,
  sourceType: z.array(z.enum(LabelSourceType)).transform(uniq).optional().catch(undefined),
  // Navigation contract: the Uploads tab "View events" row action passes sourceId to filter events by submission.
  sourceId: nonEmptyStrings,
})

export type FraudAnalysisDatasetEventsSearchParams = z.infer<typeof fraudAnalysisDatasetEventsSearchSchema>

export const Route = createFileRoute(
  '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/dataset/events'
)({
  validateSearch: fraudAnalysisDatasetEventsSearchSchema,
  component: FraudAnalysisDatasetEventsPage,
  loaderDeps: ({ search }) => ({ hasFilters: Object.values(search).some((value) => value !== undefined) }),
  loader: ({ context: { queryClient, buildRequest, fraudScoreEntitlement }, params: { subscriptionId }, deps }) => {
    // The router's `buildRequest` sends arrays as `key[]`, which Legendary Blade does not read. Only the
    // unfiltered view is prefetched; filtered views are fetched by the page with Legendary Blade's format.
    if (fraudScoreEntitlement === 'disabled' || deps.hasFilters) {
      return
    }

    void queryClient.prefetchInfiniteQuery(fraudScoreLabelledEventsQueryOptions(buildRequest, subscriptionId))
  },
})
